import React, { useState, useEffect } from 'react';
import { AdUnit } from '../components/AdUnit';

const AD_SLOT_IN_ARTICLE = '4728259285'; // In-article – fluid

export function FAQPage() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const res = await fetch('https://should-i-get-reparations-backend.vercel.app/api/pages/faq');
      const data = await res.json();
      if (data.success) {
        setContent(data.data);
      }
    } catch (err) {
      console.error('Failed to fetch FAQ content:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading…</div>;

  return (
    <div>
      <h1>{content?.title || 'FAQ'}</h1>
      <div dangerouslySetInnerHTML={{ __html: content?.content || 'Answers to common questions.' }} />
      {/* In-article ad after the FAQ content */}
      <AdUnit slot={AD_SLOT_IN_ARTICLE} format="fluid" layout="in-article" />
    </div>
  );
}
